import { apiMiddleware } from "../api.middleware";
import { DatabaseModel } from "./databases.interface";

export const getDatabasesNames = apiMiddleware<DatabaseModel[]>()({
  method: "get",
  endpoint: "/records/dbnames",
});
